<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

  <v-row class="view">
    <v-col class="col-2 pl-5  d-none d-md-inline">
      <v-img v-for="i in [0,1,2,3,4,5]"
             v-if="promotion.product_promotions[i] && promotion.product_promotions[i].product && promotion.product_promotions[i].product.image_path"
             :src="'/'+promotion.product_promotions[i].product.image_path+'.175.jpg'"
             aspect-ratio="1"
             class="grey lighten-2 float-left"
             style="width: 50%"
      >
        <span v-if="i===3 && promotion.product_promotions.length>6"
              class="more">+{{ promotion.product_promotions.length - 6 }}</span>

      </v-img>
      <v-img
          v-else-if="promotion.product_promotions[i]"
          :src="'/images/products/default.175.jpg'"
          aspect-ratio="1"
          class="grey lighten-2 float-left"
          style="width: 50%"
      >
        <span v-if="i===3 && promotion.product_promotions.length>6"
              class="more">+{{ promotion.product_promotions.length - 6 }}</span>

      </v-img>
      <v-img
          v-else
          aspect-ratio="1"
          class="grey lighten-2 float-left"
          style="width: 50%;opacity: 0"
      >
        <span v-if="i===3 && promotion.product_promotions.length>6"
              class="more">+{{ promotion.product_promotions.length - 6 }}</span>

      </v-img>


    </v-col>
    <v-col class="detail offset-1 offset-md-0">
      <!--{{ promotion.nickcode}}-->
      <div class="nickname">
        {{ promotion.name }}

      </div>
      <div class=" text-left stock">
          <span class="float-right">
            เหลือ {{ $helper.number_format(Promotion.calStock(promotion)) }}<span
              class="unit">ชุด</span>
            /
          ราคา {{ promotion.total_price }}<span class="currency">บ.</span>
          </span>

      </div>

    </v-col>
    <v-col class="col-4 col-md-3 text-right pr-5">
      <v-btn :class="$store.state.carts.current_promotion_map[promotion.id]?'primary':''" :loading="is_loading"
             class="add-button"
             @click.stop="onClickAddCart(promotion)">เพิ่ม
        <span v-if="$store.state.carts.current_promotion_map[promotion.id]">
              {{
            $store.state.carts.current_promotion_map[promotion.id][0].quantity / promotion.product_promotions[0].quantity
          }}</span>
      </v-btn>
    </v-col>
  </v-row>


</template>
<style lang="scss" scoped>
.view {
  .col {
    padding: 6px;
  }
}

.detail {
  font-size: 14px;
}

.nickname {
  height: 40px;
  overflow-y: hidden;
}

.stock {
  font-size: 16px;
}

.unit {
  font-size: 0.7em;
}

.percent {
  font-size: 0.7em;
}

.currency {
  /*display: block;*/
  /*width: 32px;*/
  /*float: right;*/
  font-size: 0.7em;
}

.more {
  display: block;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  text-align: center;
  padding-top: 25%;
  color: #FFF;
  //font-weight: bold;
  font-size: 0.4em;
}


@media (max-height: 700px) {
  .add-button {
    padding: 0 4px !important;
    min-width: 10px !important;
  }
}


</style>

<script lang="ts">

import {Promotion} from '@/models/Promotion'
import {Component, Prop, Vue} from 'vue-property-decorator'

@Component({
  components: {},
})
export default class PromotionRowColumn2 extends Vue {
  @Prop() promotion: Promotion
  @Prop() onClickAddCart: Function
  @Prop() is_loading: Boolean

  Promotion = Promotion
}

</script>
